import { render, staticRenderFns } from "./ThemeSettingModal.vue?vue&type=template&id=159e6272&"
import script from "./ThemeSettingModal.vue?vue&type=script&lang=js&"
export * from "./ThemeSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSettingModal.vue?vue&type=style&index=0&id=159e6272&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports